export const BUTTON_TEXT = 'Get Started'
export const DESCRIPTION_TEXT =
  'Lower stress. Higher self-confidence. Stronger relationships.'
